export default "__VITE_ASSET__Z_fAOahF__"